(function (Drupal, $, once) {
  Drupal.behaviors.on_this_page = {
    attach: function (context) {
      $(function () {
        var sectionList = [];
        var hash = window.location.hash;

        $(once('field-on-this-page-1', ".field-on-this-page__list"))
          .closest(".node__content")
          .find("H2:not(.dont-show)")
          .each(function () {
            sectionList.push($(this));
          });

        $(once('field-on-this-page-2', ".field-on-this-page__list"))
          .each(function () {
            if (sectionList.length > 0) {
              for (let i = 0; i < sectionList.length; i++) {
                var elem = sectionList[i];
                elem.attr("id", "section-target-" + (i + 1));
                $(this).append(
                  '<li><a href="#section-target-' +
                    (i + 1) +
                    '">' +
                    elem.text() +
                    "</a></li>"
                );
              }
              $(".field-on-this-page__content").fadeIn(300);

              if (hash) {
                $("html, body")
                  .stop()
                  .animate({
                    scrollTop:
                      $(hash).offset().top - $("#global-header").height(),
                  });
              }
            } else {
              $(this).parent().parent().remove();
            }
          });

        //scrolling the hyperlinks manually to accomodate for sticky header height
        $(document).on(
          "click",
          ".field-on-this-page__list >li>a",
          function (e) {
            e.preventDefault();
            var target = $(this).attr("href");
            if (target) {
              $("html, body").stop().animate({
                scrollTop:
                  $(target).offset().top - 16 - $("#global-header").height(),
              });
            }
          }
        );
      });
    },
  };
}(Drupal, jQuery, once));
